<template>
	<div class="" id="pageTop" style="padding:1rem 1rem 10rem">
		<div class="row">
			<div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-8 ">
				<div class="row">
					<div class="col-12 col-md-5 my-3" align="center">
						<ImageUploader type="profile" :docId="profileDoc" :currentImg="(userProfile.imgFileName) ? `${userProfile.imgFile}` : false" :folder="`${userProfile.UUID}/profile`" />
					</div>
					<div class="col-12 col-md-7 my-3">
						<ul class="list-group">
							<li class="list-group-item" align="right">
                                <!-- <button class="btn btn-primary col-12" @click="$router.push('/messages')">
									Messages <span class="badge badge-pill badge-light ml-2">{{msgCount.length}}</span>
								</button> -->
								<button class="btn btn-primary col-12 my-2" data-toggle="modal" data-target="#editProfileModal" @click="btnEditProfileClick">
									Edit profile
								</button>
								<button class="btn btn-outline-primary col-12 my-2" @click="btnLogoutClick">
									Log out
								</button>
								<button class="btn btn-outline-primary col-12 my-2" @click="btnResetPassword">
									Reset password
								</button>
							</li>
							<li class="list-group-item">
								<small class="text-muted">Name:</small><br/>
								{{userProfile.fname}} {{userProfile.lname}}
							</li>
							<li class="list-group-item">
								<small class="text-muted">Email Address:</small><br/>
								{{userProfile.email}} <small><i v-if="user.emailVerified" class="text-primary fas fa-check-circle"></i></small>
							</li>
							<li class="list-group-item">
								<small class="text-muted">Phone:</small><br/>
								{{userProfile.phone}}
							</li>
							<li class="list-group-item">
								<small class="text-muted">Gender:</small><br/>
								{{userProfile.gender}}
							</li>
							<li class="list-group-item">
								<small class="text-muted">Country:</small><br/>
								{{userProfile.country}}
							</li>
							<li class="list-group-item">
								<small class="text-muted">Date of Birth:</small><br/>
								{{userProfile.dob}}
							</li>
                            <li class="list-group-item">
								<small class="text-muted">Relationship Status:</small><br/>
								{{userProfile.rStatus}}
							</li>
							<li class="list-group-item">
								<small class="text-muted">Profession:</small><br/>
								{{userProfile.job}}
							</li>
							<li class="list-group-item">
								<small class="text-muted">Interests:</small><br/>
								{{(Array.isArray(userProfile.interests)) ? userProfile.interests.join(", ") : ''}}
							</li>
							<li class="list-group-item">
								<small class="text-muted">My Data:</small><br/>
								<button class="btn btn-link btn-sm" @click="btnLogoutClick">
									Delete my Rotary International District 7030 Conference profile
								</button>
							</li>
						</ul>
					</div>
				</div>
            </div>
            <div class="col-12 col-md-2">
            </div>
		</div>

		<!-- Modal -->
		<div class="modal fade" id="editProfileModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title mkt-title" >Edit Profile</h4>
						<button type="button" id="btnCloseProfileModal" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding:1rem 3rem">
						<div class="row">
							<div  class="col-12 col-lg-6 my-2" >
								<label>First name*</label>
								<input type="text" class="form-control" v-model="profile.fname" />
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Last name*</label>
								<input type="text" class="form-control" v-model="profile.lname" />
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Email address*</label>
								<input type="text" readonly class="form-control" v-model="profile.email" />
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Phone*</label>
								<VuePhoneNumberInput @update="getPhone" v-model="profile.phone" :preferred-countries="['US', 'GB', 'CA']" :fetch-country="true"/>
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Gender*</label>
								<select class="form-control" v-model="profile.gender">
									<option value="" disabled selected>Please select</option>
									<option>FEMALE</option> 
                                    <option>MALE</option> 
                                    <option>NON-BINARY</option> 
								</select>
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Country*</label>
								<select class="form-control" v-model="profile.country">
                                    <option value="" selected disabled>Please select</option>
                                    <option value="ANGUILLA">ANGUILLA</option>
                                    <option value="ANTIGUA AND BARBUDA">ANTIGUA AND BARBUDA</option>
                                    <option value="ARUBA">ARUBA</option>
                                    <option value="BARBADOS">BARBADOS</option>
                                    <option value="BONAIRE">BONAIRE</option>
                                    <option value="CURACAO">CURAÇAO</option>
                                    <option value="DOMNICA">DOMINICA</option>
                                    <option value="FRENCH GUIANA">FRENCH GUIANA</option>
                                    <option value="GRENADA">GRENADA</option>
                                    <option value="GUADELOUPE">GUADELOUPE</option>
                                    <option value="GUYANA">GUYANA</option>
                                    <option value="JAMAICA">JAMAICA</option>
                                    <option value="MARTINIQUE">MARTINIQUE</option>
                                    <option value="MONTSERRAT">MONTSERRAT</option>
                                    <option value="SAINT KITTS AND NEVIS">SAINT KITTS AND NEVIS</option>
                                    <option value="SAINT LUCIA">SAINT LUCIA</option>
                                    <option value="SAINT VINCENT AND THE GRENADINES">SAINT VINCENT AND THE GRENADINES</option>
                                    <option value="SURINAME">SURINAME</option>
                                    <option value="TRINIDAD AND TOBAGO">TRINIDAD AND TOBAGO</option>
                                    <option disabled>------</option>
                                    <option>OTHER</option>
                                </select>
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Date of birth*</label>
								<input type="date" class="form-control" v-model="profile.dob" />
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Relationship Status*</label>
								<select class="form-control" v-model="profile.rStatus">
									<option value="" disabled selected>Please select</option>
									<option>Dating</option>
									<option>Divorced</option>
									<option>Married</option>
									<option>Single</option>
									<option>Situationship</option>
								</select>
							</div>
							<div  class="col-12 col-lg-6 my-2" >
								<label>Profession*</label>
								<select class="form-control" v-model="profile.job">
									<option value="" disabled selected>Please select</option>
									<option>Accounting</option>
									<option>Advertising</option>
									<option>Aerospace</option>
									<option>Agribusiness</option>
									<option>Airlines</option>
									<option>Alcoholic Beverages</option>
									<option>Architecture</option>
									<option>Attorney</option>
									<option>Automotive</option>
									<option>Banking</option>
									<option>Business Services</option>
									<option>Civil Servant</option>
									<option>Communications</option>
									<option>Construction</option>
									<option>Consultant</option>
									<option>Education</option>
									<option>Entertainment</option>
									<option>Engineering</option>
									<option>Food and Beverage</option>
									<option>Finance</option>
									<option>Government</option>
									<option>Information Technology</option>
									<option>Insurance</option>
									<option>Management</option>
									<option>Manufacturing</option>
									<option>Marketing</option>
									<option>Media</option>
									<option>Medical /Health Professional</option>
									<option>NGO</option>
									<option>Public Relations</option>
									<option>Publishing</option>
									<option>Media</option>
									<option>Real Estate</option>
									<option>Science</option>
									<option>Sports</option>
									<option>Telecommunications</option>
									<option>Tourism</option>
									<option>Transport</option>
									<option>Vanture Capital</option>
									<option>Waste Management</option>
									<option disabled>-------</option>
									<option>Other</option>
									<option>Job Hunting</option>
								</select>
							</div>
							<!-- <div  class="col-12 my-2" >
								<label>About Me</label>
								<textarea rows="4" wrap="hard" class="form-control" v-model="profile.aboutme" />
							</div> -->
							<div  class="col-12 my-2" >
								<label>Interests*</label>
							</div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Charity" v-model="profile.interests" /> Charity
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Disease Prevention and Treatment" v-model="profile.interests" /> Disease Prevention and Treatment
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Education and Literacy" v-model="profile.interests" /> Education and Literacy
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Economic and Community Development" v-model="profile.interests" /> Economic and Community Development
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Family" v-model="profile.interests" /> Family
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Food and Drink" v-model="profile.interests" /> Food and Drink
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Healthcare and Exercise" v-model="profile.interests" /> Healthcare and Exercise
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Learning" v-model="profile.interests" /> Learning
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Maternal and Child Health" v-model="profile.interests" /> Maternal and Child Health
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Peace and Conflict Resolution" v-model="profile.interests" /> Peace and Conflict Resolution
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Photography" v-model="profile.interests" /> Photography
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Politics" v-model="profile.interests" /> Politics
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Sports" v-model="profile.interests" /> Sports
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Technology" v-model="profile.interests" /> Technology
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Theatre" v-model="profile.interests" /> Theatre
                                </label>
                            </div>
							<div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Travel" v-model="profile.interests" /> Travel
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Water and Sanitation" v-model="profile.interests" /> Water and Sanitation
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="Youth Development" v-model="profile.interests" /> Youth Development
                                </label>
                            </div>
							<div class="col-12 my-1">
								<hr size="1" />
                                <label>
                                    <input type="checkbox" value="true" v-model="profile.dataConsent" /> I agree to allow Rotary International District 7030 to store and process my personal data.*
                                </label>
                            </div>
                            <div class="col-12 my-2">
                                <small>
                                    By submitting this form you are agreeing to Rotary International District 7030's <a href="#!" target="_legal">Terms and Privacy Policy*</a>
                                </small>
                            </div>
							<div  class="col-12 my-3" >
								<button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid || isBusy" @click="btnSubmitClick">
									<span v-show="!isBusy">Update Profile</span>
									<div class="spinner-border text-light" role="status" v-show="isBusy">
										<span class="sr-only">Loading...</span>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueToast from 'vue-toast-notification'
	import 'vue-toast-notification/dist/theme-sugar.css'
	import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    import ImageUploader from '@/components/ImageUploader'

	Vue.use(VueToast)

	const fb = require("../firebaseConfig")
	export default {
		name: 'Profile',
		filters: {

		},
		components: {
			VuePhoneNumberInput, ImageUploader,
		},
		computed:{
			userProfile(){
				return this.$store.state.userProfile
			},
            profileDoc(){
                return this.$store.state.profileDoc
            },
            user(){
                return this.$store.state.loggedInUser
            },
            msgCount(){
                return []
            },
			isFormValid(){
				if(!this.profile.fname) return false
                if(!this.profile.lname) return false
                if(!this.profile.email) return false
                if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.profile.email)) return false
                if(!this.profile.phone) return false
                if(!this.profile.gender) return false
                if(!this.profile.country) return false
				if(!this.profile.dob) return false
				if(!this.profile.rStatus) return false
				if(!this.profile.job) return false
				if(this.profile.interests.length<1) return false
                if(!this.profile.dataConsent) return false
				return true
			}
		},
		data(){
			return{
				isBusy: false,
				profile:{interests:[]},
				isPhoneValid:true,
			}
		},
		methods:{
			btnLogoutClick(){
				this.$store.dispatch('logOut')
			},
			btnEditProfileClick(){
				this.profile = this.userProfile
                this.profile.interests = (this.userProfile.interests) ? this.userProfile.interests : []
				this.profile.dataConsent = false
				this.profile.profileStatus = true 
			},
			btnEditProfileImgClick(){

			},
			async btnSubmitClick(){
				this.isBusy = true
				this.profile.updated = Math.floor(Date.now()/1000)
				fb.usersCollection.doc(this.$store.state.profileDoc).update(this.profile).then(()=>{
					Vue.$toast.success("Your profile was updated.", {position:"top"})
                    document.getElementById("btnCloseProfileModal").click()
                    this.isBusy = false
				})
			},
			btnResetPassword(){
				this.isBusy = true
				fb.firebase.auth().sendPasswordResetEmail(this.userProfile.email).then(()=> {
                    Vue.$toast.success("A password reset link was sent to your email address.", {position:"top"})
					this.isBusy = false
                }).catch(()=> {
                    this.isBusy = false
                })
			},
            getPhone(e){
                this.profile.formattedPhone = e.formattedNumber
                this.isPhoneValid = e.isValid
            },
		},

		mounted(){
			//this.$store.commit("setPageTitle", "Profile")
            //console.log(this.userProfile)
        }

	}
</script>
